import React, { useState, useEffect } from "react";
import axios from "axios";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Navigate, useNavigate } from "react-router-dom";

//import bootstrap components
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

//import css
import "./Login.css";

const LoginPage = () => {
	const [authenticated, setAuthenticated] = useState(false);
	const [errMsg, setErrMsg] = useState(false);
	const [errMsgContent, setErrMsgContent] = useState("");

	const serverUrl = `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_SERVER_HOST}:${process.env.REACT_APP_SERVER_HOST_PORT}`;

	const redirect = useNavigate();
	const handleLogin = (values: any) => {
		axios
			.post(`${serverUrl}/api/login`, values, {
				withCredentials: true,
			})
			.then(function (response) {
				if (
					response.data.msg === "Login Successful" &&
					response.status === 200
				) {
					setErrMsgContent("");
					setErrMsg(false);
					redirect("/");
				} else {
					setErrMsgContent("Incorrect username or password");
					setErrMsg(true);
				}
			})
			.catch(function (error) {
				console.error(error);
				setErrMsgContent(`Exception: ${serverUrl}/api/login`);
				setErrMsg(true);
			});
	};

	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${serverUrl}/api/protected`, {
					withCredentials: true,
				});
				const apiData = response.data;

				if (
					apiData.status === "success" &&
					apiData.msg === "user is authenticated"
				) {
					setAuthenticated(true);
				} else {
					setAuthenticated(false);
				}
			} catch (error) {
				console.error(error);
				setErrMsgContent("Error: ");
				setAuthenticated(false);
			}
		};

		fetchData();
	}, [serverUrl]);

	return !authenticated ? (
		<div className="login-page">
			<Container className="login-container">
				<img
					className="qflo-login-logo-mobi"
					alt="logo"
					src="/media/images/qfloLoginMoi.png"
				/>
				<Row className="test-row">
					<Col
						xs={12}
						md={6}
						className="login-col"
					>
						<div className="login-div">
							<h1 style={{ fontSize: "32px" }}>Log In</h1>
							<p style={{ fontSize: "12px" }}>
								Enter your username and password to login your dashboard
							</p>
							<Formik
								initialValues={{
									username: "",
									password: "",
								}}
								validationSchema={Yup.object({
									username: Yup.string().required("Required"),
									password: Yup.string().required("Required"),
								})}
								onSubmit={(values) => handleLogin(values)}
							>
								<Form className="login-form">
									<label>Username</label>
									<Field
										name="username"
										type="text"
										placeholder="Enter Username"
										className="login-form-input"
									/>
									<p className="err-msg">
										<ErrorMessage name="username" />
									</p>

									<label>Password</label>
									<Field
										name="password"
										type="password"
										placeholder="Enter password"
										className="login-form-input"
									/>
									<p className="err-msg">
										<ErrorMessage name="password" />
									</p>
									{errMsg ? <p className="err-msg">{errMsgContent}</p> : false}
									<Button
										className="login-btn"
										type="submit"
									>
										Login
									</Button>
								</Form>
							</Formik>
						</div>
					</Col>
					<Col
						xs={12}
						md={5}
						className="login-col-2"
					>
						<img
							className="qflo-login-logo"
							alt="logo"
							src="/media/images/qfloLogin.png"
						/>
					</Col>
				</Row>
			</Container>
		</div>
	) : (
		<Navigate to="/" />
	);
};

export default LoginPage;
